import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import DocumentTitle from 'react-document-title'
import ProfilesList from './ProfilesList'
import ProfilesDashboard from './dashboard/ProfilesDashboard'

const profilesBreadcrumbs = (title: string): Array<PageLink> => [
  {
    title,
    path: '/profiles/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ProfilesPage = () => {
  const intl = useIntl()
  const profilesTitle = intl.formatMessage({ id: 'MENU.PROFILES' })
  const dashboardTitle = intl.formatMessage({ id: 'PROFILES_DASHBOARD.TITLE' })
  const breadcrumbs = profilesBreadcrumbs(profilesTitle)
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='dashboard'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | ' + dashboardTitle} />
              <PageTitle breadcrumbs={breadcrumbs}>{dashboardTitle}</PageTitle>
              <ProfilesDashboard />
            </>
          }
        />
        <Route
          path='list'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | ' + profilesTitle}
              ></DocumentTitle>
              <PageTitle breadcrumbs={breadcrumbs}>{profilesTitle}</PageTitle>
              <ProfilesList />
            </>
          }
        />
        <Route index element={<Navigate to='/profiles/dashboard' />} />
      </Route>
    </Routes>
  )
}

export default ProfilesPage
